import { Injectable, inject } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { MittMaskinlagDTO } from "~app/common/models/planera/MittMaskinlagDTO";
import { IMaskinlagForArbetsorderResponse, ISaveMinaMaskinlagRequest, ISaveMinaMaskinlagResponse } from "~app/features/planera/mina-maskinlag/mina-maskinlag.models";
import { IMaskinlag } from "~app/features/planera/model/IMaskinLag";
import { ApiClientService } from "../services/api-client.service";
import { EventService, IEventTransferObject } from "./cqs/event.service";

@Injectable({
    providedIn: "root"
})
export class MaskinlagService {
    private readonly apiClientService = inject(ApiClientService);
    private readonly eventService = inject(EventService);

    getAllMaskinlag(): Promise<IMaskinlag[]> {
        return firstValueFrom(this.apiClientService.get<IMaskinlag[]>(`Planera/GetAllMaskinlag`, true));
    }

    getMinaMaskinlag(): Promise<IMaskinlag[]> {
        return firstValueFrom(this.apiClientService.get<IMaskinlag[]>(`Planera/GetMinaMaskinlag`, true));
    }

    getMinaMaskinlagAndOperationer(startdatum: Date): Promise<IMaskinlagForArbetsorderResponse> {
        return firstValueFrom(this.apiClientService.get<IMaskinlagForArbetsorderResponse>(`Planera/GetMinaMaskinlagAndOperationer`, true, {
            startdatum: startdatum
        }));
    }

    getMaskinlagForArbetsorder(arbetsorderId: number, startdatum: Date): Promise<IMaskinlagForArbetsorderResponse> {
        const params: any = {
            arbetsorderId: arbetsorderId
        };

        if (startdatum) {
            params.startdatum = startdatum;
        }

        return firstValueFrom(this.apiClientService.get<IMaskinlagForArbetsorderResponse>(`Planera/GetMaskinlagForArbetsorder`, true, params));
    }

    saveMinaMaskinlag(minaMaskinlag: IMaskinlag[]): Promise<ISaveMinaMaskinlagResponse> {
        const minaMaskinlagMedSortering = this.insertSortSequenceToMinaMaskinlag(minaMaskinlag);
        const promise = firstValueFrom(this.apiClientService
            .post<ISaveMinaMaskinlagRequest, ISaveMinaMaskinlagResponse>(`Planera/SaveMinaMaskinlag`, {
                maskinlag: minaMaskinlagMedSortering
            }, true));

        promise.then(response => {
            this.emitIfEvents(response);
        });

        return promise;
    }

    private insertSortSequenceToMinaMaskinlag(minaMaskinlag: IMaskinlag[]): MittMaskinlagDTO[] {
        return minaMaskinlag.map((m, index) => (({
            ...m,
            sekvensnummer: index
        })));
    }

    private emitIfEvents<T extends IEventTransferObject>(response: T) {
        if (response && response.events) {
            response.events.forEach(this.eventService.emit);
        }
        return response;
    }
}
